import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { api } from '../../../../../../api';
import Skeleton from '../../../../../../components/Skeleton';
import Select from '../../../../../../components/Select';
import { debouncer } from '../../../../../../utils/debouncer';
import './styles.scss';

const LinkUserToEnterpriseModal = ({ setError, data, onClose }) => {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState({});
  const [userInfoResponse, setUserInfoResponse] = useState({});
  const [pj, setPj] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [ativo, setAtivo] = useState('');
  const [search, setSearch] = useState();
  const [searchOptions, setSearchOptions] = useState([]);
  
  const handleSubmit = useCallback(() => {
    setLoading(true);
    if (!search || !search.selected) {
      setError(formatMessage({ id: "erro-api" }));
      return;
    }

    api.post(`/users/link_to_enterprise`, {
      pj: search.selected,
      is_admin: isAdmin,
      ativo: ativo,
      user_info: {
        username: info.email,
        pessoa_fisica_id: info.pessoa_fisica_id,
        pessoa_id: info.pessoa_id,
      }
    })
      .then(() => {
        setLoading(false);
        alert('Cadastro Atualizado com sucesso!');
        onClose();
      })
      .catch((err) => {
        setError(err.data.message || formatMessage({ id: "erro-api" }));
        setLoading(false);
      });
  }, [search, isAdmin, ativo, setError, formatMessage, info, onClose])

  const getUserInfo = useCallback(() => {
    api.get(`/users/get_user_info?username=${data}`)
      .then(({ data: response }) => {        
        setUserInfoResponse(response);
        setInfo(response.Usuario);

        if (response.PessoaJuridica) {
          setAtivo(response.PessoaJuridica.ativo);
          setIsAdmin(response.PessoaJuridica.is_admin);
          setPj(response.PessoaJuridica.nome_fantasia);

          handleSetOptions([response])
        }
        
        setLoading(false);
      })
      .catch(() => {
        setError(formatMessage({ id: "erro-api" }));
        setLoading(false);
      });
  }, [data, formatMessage, setError]);

  const handleSetOptions = (options) => {
    const parsed = options.map(option => {
      return {
        value: option.PessoaJuridica.id,
        label: option.PessoaJuridica.nome_fantasia
      }
    })

    setSearchOptions(parsed);    
  }

  const handleSelectSearch = debouncer((search) => {
    if (!search) return;
    setSearch(search);

    const url = pj && search.query.length === 0
      ? `/users/get_pj_list?name=${pj}`
      : search.query.length > 0 
        ? `/users/get_pj_list?name=${search.query}`
        : ``;

    if (url !== '') {
      api.get(url)
        .then(({ data: response }) => {
          if (response.PessoaJuridica && search.query.length === 0) {
            const options = response.filter(result => {
              return userInfoResponse.PessoaJuridica.id === result.PessoaJuridica.id
            })

            handleSetOptions(options);
          } else {
            handleSetOptions(response);
          }
        })
        .catch(() => {
          setError(formatMessage({ id: "erro-api" }));
          setLoading(false);
        });
    }
  }, 250);

  useEffect(() => {
    getUserInfo();
  }, [getUserInfo])

  return (
    <div className="modal link-user-to-enterprise-admin is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <div className="modal-card-title">
            {formatMessage({ id: "vincular-usuario-pj" })}
          </div>
        </header>
        <section className="modal-card-body">
          <br/>
          <div className="modal-form-enterprise">
            {!loading ? (
              <>
                <div className="modal-form-pj">
                  <strong className='pj-title'>Pessoa Jurídica</strong>
                  <Select
                    options={searchOptions}
                    querying
                    selectFirstIfEquals={pj}
                    onChange={e => {
                      handleSelectSearch(e)
                    }}
                  />{" "}
                </div>
                <div className="modal-form-user-options">
                  <div className="input-user">
                    <span>
                      {formatMessage({ id: 'administrador' })}{" "}
                    </span>
                    <input
                      data-testid="is-admin"
                      type="checkbox"
                      checked={isAdmin}
                      onChange={e => setIsAdmin(e.target.checked)}
                    />                  
                  </div>
                  <div className="input-user">
                    <span>
                      {formatMessage({ id: 'cadastro-ativo' })}{" "}
                    </span>
                    <input
                      data-testid="ativo"
                      type="checkbox"
                      checked={ativo}
                      onChange={e => setAtivo(e.target.checked)}
                    />
                  </div>
                </div>
              </>
            ) : (
              <Skeleton width="40" />
            )}
          </div>
        </section>
        <footer className="modal-card-foot">
          <button
            className="button danger"
            onClick={onClose}
          >
            {formatMessage({ id: "cancelar" })}
          </button>

          <button
            className={`button primary ${loading ? "is-loading" : ""}`}
            onClick={handleSubmit}
          >
            {formatMessage({ id: "continuar" })}
          </button>
        </footer>
      </div>
    </div>
  )
}

export default LinkUserToEnterpriseModal;